<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 30 30" fill="none">
    <g clip-path="url(#clip0_2116_2369)">
      <path d="M15 7.4875L24.4125 23.75H5.5875L15 7.4875ZM15 2.5L1.25 26.25H28.75L15 2.5Z" :fill="color" />
      <path d="M16.25 20H13.75V22.5H16.25V20Z" :fill="color" />
      <path d="M16.25 12.5H13.75V18.75H16.25V12.5Z" :fill="color" />
    </g>
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: String,
      default: '20px',
    },
    color: {
      type: String,
      default: 'var(--bs-primary)',
    },
  });
</script>

<style lang="css">
  path.location-icon__path {
    fill: var(--bs-primary);
  }
</style>
